import React from 'react'
import ProductSection from './ProductSection'
import NewsletterSignup from './NewsletterSignup'
import Ourgallery from './Ourgallery'
import Awards from '../Awards'
import Yearsexp from './Yearsexp'
import ProductCarousel from './ProductCarousel'
import SupplierSection from './SupplierSection'
import Gallery from './Gallery'
import Banner from './Banner'
import Slide from './Slide'
import W3sect from './W3sect'
import VideoSection from './VideoSection'
import Faq from './Faq'
import PartnersMarquee from './PartnersMarquee'
import Testimonials from './Testimonials'
import ExperienceCounter from './ExperienceCounter'
import ExperienceTimeline from './ExperienceTimeline'
import Exp from './Exp'
import Carouselmain from './Carouselmain'

function Herosection() {
  return (
    <div className="page">
        

      <section>
        <Slide/>
      </section>
      {/* <section style={{backgroundColor:"#f5f5f5"}}>
        <ProductCarousel/>
      </section> */}
      <section>
        <Carouselmain/>
      </section>
      <section>
        <VideoSection/>
      </section>
      <section>
        <W3sect/>
      </section>
     
      <section>
        <Gallery/>
      </section>
      <section>
        <Exp />
      </section>
      <section>
        <Testimonials/>
      </section>
      
      <section>
        <Faq/>
      </section>
      <section>
        <PartnersMarquee/>
      </section>
      
    </div>
  )
}

export default Herosection
